var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "local-favorites-left" },
    _vm._l(_vm.media, function(block, index) {
      return index < 2
        ? _c("Media-Block", {
            key: "menu-block-" + index,
            attrs: {
              "class-prefix": "featured-item",
              "inline-modals": false,
              block: block
            }
          })
        : _vm._e()
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/MenuBlocks.vue?vue&type=template&id=e933253a&
// module id = 447
// module chunks = 0